module.exports = __webpack_public_path__ + "static/media/comment-slash.4e8cd6dd.svg";